<script>
import PoupChild from './PoupChild';
export default {
  name: 'Poup',
  components: {
    PoupChild
  },
  data: function () {
    return {
      layerName: ''
    };
  },
  created () {
    this.layers = [];
    this.keepAliveNames = [];
    this.$bus.$on('OPEN_LAYER', opts => {
      this.addLayer(opts.layerName, opts.keepAlive || false, opts.layerData);
    });
    this.$bus.$on('CLOSE_LAYER', ({ layerName }) => {
      this.deleteLayer(layerName);
    });
  },
  methods: {
    addLayer (layerName, keepAlive, layerData) {
      if (layerName) {
        this.deleteLayer(layerName);
      }
      this.layers.push({
        layerName,
        keepAlive,
        layer: <PoupChild
          index={this.layers.length}
          keepAlive={keepAlive}
          key={layerName}
          layerData={{ ...layerData }}
          layer-name={layerName}
        ></PoupChild>
      });
      this.layerName = this.layers.map(o => o.layerName);
    },
    deleteLayer (layerName) {
      if (layerName) {
        let index = this.layers.findIndex(o => o.layerName === layerName);
        if (index > -1) {
          this.layers.splice(index, 1);
        }
      } else {
        this.layers.pop();
      }
      this.layerName = this.layers.map(o => o.layerName);
    }
  },
  render (h) {
    const keepALiveLayers = this.layers.filter(o => o.keepAlive);
    keepALiveLayers.forEach(layerOpts => {
      if (!this.keepAliveNames.includes(layerOpts.layerName)) {
        this.keepAliveNames.push(layerOpts.layerName);
      }
    });
    const layers = this.layers.filter(o => !o.keepAlive).map(o => o.layer);
    return h('div', {
      attrs: { layerName: this.layerName },
    }, [
      this.keepAliveNames.map(layerName => {
        return <keep-alive>
          {keepALiveLayers.find(o => o.layerName === layerName)?.layer}
        </keep-alive>;
      }),
      ...layers]);
  }
};
</script>